import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import { PageHeader, StatusBadge } from '../../ui'

export default function Reservations() {

  const [createNewFlag, setCreateNewFlag] = useState(false)
  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['Reservations_Access Specifier']);
    }

  }, []);


  return (
    <>
      <PageHeader
        title="Reservations"
        subtitle="Search, filter, and review reservation activity across accounts and locations."
        eyebrow="Operations"
        help={(
          <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
            Help
          </button>
        )}
      >
        {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
      </PageHeader>

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="reservations-help-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="reservations-help-title">
            Instructions to view Reservations
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ol>
            <li>Select the Account Name from the dropdown.</li>
            <li>Select the Location Name from the dropdown.</li>
            <li>Select the required car class.</li>
            <li>Filter reservations using Booked Date, Drop-off Date, or Pick-up Date.</li>
            <li>Filter booking status using All, Valid, Cancelled, or No Show.</li>
            <li>Select a From and To date, then choose Fetch.</li>
          </ol>

          <h5>Existing Reservations</h5>
          <p>
            Select an account and location, then use the car class, booking status,
            and date filters to review reservation details.
          </p>
        </Modal.Body>
      </Modal>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </>
  );
}
